var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E8F0FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12262_73050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3352 30.3327C33.6225 29.5469 32.7636 29.1631 31.667 29.1631H29.3566L27.8397 27.7012C26.725 28.6149 25.3726 29.1449 23.9105 29.1449C22.5399 29.1449 21.2423 28.6698 20.1824 27.8474L18.8299 29.1449H16.4254C15.2009 29.1449 14.2506 29.5652 13.5013 30.4242C11.3266 32.9462 11.6921 38.3374 11.8566 40.0005H36.1992C36.3272 38.319 36.5465 32.7999 34.3352 30.3327Z",
    fill: "#3077F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5757 18.8916C17.1371 19.2571 16.8447 19.8419 16.8447 20.5181C16.8447 21.5232 17.5026 22.3456 18.3433 22.4918C18.526 24.0087 19.1474 25.3428 20.0794 26.3296C20.2804 26.5306 20.4814 26.7317 20.7007 26.8962C20.9749 27.1155 21.2673 27.2982 21.578 27.4627C22.2724 27.8281 23.0399 28.0292 23.8624 28.0292C24.6847 28.0292 25.4524 27.8281 26.1468 27.4627C26.4574 27.2982 26.7498 27.1155 27.024 26.8962C27.2433 26.7317 27.4443 26.5306 27.6453 26.3296C28.5591 25.3428 29.1987 24.0269 29.3632 22.5101C29.3815 22.5101 29.3998 22.5101 29.418 22.5101C30.3867 22.5101 31.1542 21.6146 31.1542 20.5181C31.1542 19.8419 30.8618 19.2571 30.4232 18.8916H17.5757Z",
    fill: "#3077F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5401 15.0544C29.9735 13.1721 28.475 11.2532 26.5743 10.2663V14.561V15.1458C26.5743 15.1824 26.5743 15.2006 26.5743 15.2189C26.5561 15.4199 26.5195 15.6027 26.4282 15.7854C26.1906 16.2423 25.7154 16.5713 25.1672 16.5713H24.8748H22.8645C22.3528 16.5713 21.8959 16.2972 21.6584 15.8951C21.5487 15.7306 21.4939 15.5479 21.4573 15.3468C21.4391 15.2737 21.4391 15.2189 21.4391 15.1458V14.6341V10.248C19.5384 11.2532 18.0399 13.1721 17.4733 15.0544L17.3454 15.4565H16.3037V17.7409H17.4551H19.0633H19.7395H28.5482H29.2061H31.6965V17.6312V15.4565H30.6681L30.5401 15.0544Z",
    fill: "#3077F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.858 16.0046H25.1424C25.4713 16.0046 25.7454 15.8218 25.8916 15.5477C25.9647 15.4197 26.0013 15.2918 26.0013 15.1456V14.9811V14.305V9.992V9.37064V9.13306C26.0013 8.98686 25.9647 8.85894 25.9282 8.73101C25.7638 8.31068 25.3435 8 24.8683 8H22.858C22.4194 8 22.0538 8.32895 22.0173 8.74928C22.0173 8.78584 21.999 8.82239 21.999 8.85894V9.37064V9.992V14.3781V15.0725V15.1456C21.999 15.3284 22.0538 15.4928 22.1452 15.639C22.3098 15.8584 22.5656 16.0046 22.858 16.0046Z",
    fill: "#3077F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12262_73050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffIcon);
export default __webpack_public_path__ + "static/media/staffIcon.293cd938edcb0dc5a0c54ee700b8e0d5.svg";
export { ForwardRef as ReactComponent };